import { BaseEntityModel } from '/@/modules/core/app/models/abstracts/BaseEntityModel';
import { GoalKey } from '@/modules/goal/constants/GoalKey';

export class Goal extends BaseEntityModel {
  id?: number;
  goals?: GoalKey[];
  customGoal?: string;
  modelType: string;
  modelId: number;

  constructor(model: Partial<Goal> = {}) {
    super(model);

    this.id = model.id;
    this.modelType = model.modelType;
    this.modelId = model.modelId;
    this.goals = model.goals ?? [];
    this.customGoal = model.customGoal;
  }

  isSelected(goalKey: string): boolean {
    return this.goals.includes(goalKey);
  }
}
